<script>
import { onMount, onDestroy, tick } from 'svelte';

export let component;
export let autofocus = false;
let className = '';
export { className as class };

let frame;
let win;
let doc;
let head;
let body;
let content;
let routerListener;
let meta;
let font;

$: {
  if (content) {
    const { component, autofocus, ...props } = $$props;
    delete props.class;
    content.$set(props);
  }
}

function loadHandler() {
  win = frame.contentWindow;
  doc = frame.contentDocument;
  head = doc.head;
  body = doc.body;

  // set default body styles
  setStyles('default', `html,body {
    background: none !important;
    margin: 0 !important;
    padding:0 !important;
    overflow: hidden !important;
    height: 100% !important;
  }body { display: flex }`);

  Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
    .forEach(node => head.appendChild(node.cloneNode(true)));

  if (component) {
    const { component, autofocus, className, ...props } = $$props;
    delete props.class;
    content = new component({
      target: body,
      immutable: true,
      props,
    });
  }

  if (autofocus) {
    win.focus();
  }
}

function setStyles(name, styles) {
  var styleElement = head.querySelector('style[name="' + name + '"]');
  if (!styleElement) {
    styleElement = doc.createElement('style');
    styleElement.setAttribute('name', name);
    head.appendChild(styleElement);
  }
  styleElement.innerHTML = styles || '';
}

function inputElement(event) {
  if (event.target.nodeName === 'INPUT' || event.target.nodeName === 'TEXTAREA') {
    return event.target;
  }
}

onMount(async () => {
  await tick();
  if (frame.contentDocument.readyState === 'complete' && frame.contentDocument.defaultView) {
    loadHandler();
  } else {
    frame.addEventListener('load', loadHandler);
  }
});

onDestroy(() => {
  if (frame) frame.removeEventListener('load', loadHandler);
  if (content) content.$destroy();
  if (routerListener) routerListener();
});
</script>

<iframe class={className} bind:this={frame} title="frame"></iframe>

<style>
iframe {
  border: none;
  width: 100%;
  height: 100%;
}
</style>